export const VOLUME = 'VOLUME';
export const NAMESPACE = '_@@ezugi@@_';
